module.exports = __webpack_public_path__ + "img/chromecast_device.2e0254e5.png";